import BrochureView from "@/components/Brochure";
import { useParams } from "react-router-dom";

export default function Brochure() {
  const { market } = useParams();
  return <BrochureView market={market} />;
}
